import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import { Box, Flex, ButtonFilled, ButtonText } from 'Components/Base';
import { getTextColorByContrast } from 'Util/color';

const ModalFooter = ({
  primaryButtonLabel,
  onPrimaryButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  isPrimaryDisabled,
  ...props
}) => {
  const { colors } = useTheme();
  return (
    <Flex {...props}>
      {secondaryButtonLabel && (
        <ButtonText
          minWidth={160}
          borderRadius={25}
          onClick={onSecondaryButtonClick}
          fontWeight={500}
        >
          {secondaryButtonLabel}
        </ButtonText>
      )}
      {secondaryButtonLabel && primaryButtonLabel && (
        <Box pl={{ _: 0, md: 4 }} pt={{ _: 4, md: 0 }} />
      )}
      {primaryButtonLabel && (
        <ButtonFilled
          minWidth={160}
          borderRadius={25}
          onClick={onPrimaryButtonClick}
          disabled={isPrimaryDisabled}
          textColor={getTextColorByContrast(colors.primary, 'text', 'white')}
          fontWeight={600}
        >
          {primaryButtonLabel}
        </ButtonFilled>
      )}
    </Flex>
  );
};

ModalFooter.propTypes = {
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  isPrimaryDisabled: PropTypes.bool,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
};

ModalFooter.defaultProps = {
  onPrimaryButtonClick: () => {},
  onSecondaryButtonClick: () => {},
};

export default ModalFooter;
